<script>
import { onMounted, onUnmounted, ref, getCurrentInstance, reactive } from "vue";
import { useStore } from "vuex";
import { countByDepartment } from "@/use/repositories/devices/countByDepartment.js";
import { dateFormatter } from '@/use/utilities/time/dateFormatter';

import Modal from "@/components/Modal/Standard";
import CardCounter from "@/components/devices/CardCounter.vue";

export default {
  name: "Counters",
  props: {
    widget: { type: Boolean, default: false },
  },
  components: { CardCounter, Modal },
  setup(props) {
    const store = useStore();
    const internalInstance = getCurrentInstance();
    const pusher = internalInstance.appContext.config.globalProperties.$pusher;
    const loading = ref();
    const counters = ref();
    const alertModal = reactive({
      id: "alert-modal",
      show: false,
      title: "Attention",
      subTitle: "The tags are below the minimum number",
      area: null,
      count: null,
      lastSentAt: null,
      options: { backdrop: "static", keyboard: false },
    });

    const syncCounters = async () => {
      loading.value = true;
      try {
        const response = await countByDepartment(store.state.mainRole.team.name);
        counters.value = response?.data?.meta || [];
      } catch (error) {
        console.error("Error syncing counters:", error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      const channelName = "private-digital-labels";
      console.log(`subscribing from "${channelName}"...`, { $pusher: pusher });
      const channel = pusher.subscribe(channelName);

      channel.bind("pusher:subscription_succeeded", () =>
        console.log(`subscription succeeded to: " ${channelName}`)
      );
      channel.bind("digital-labels.alert", (data) => {
        console.log("data", data);
        alertModal.lastSentAt = data?.lastSentAt;
        alertModal.area = data?.area;
        alertModal.count = data?.count;
        alertModal.show = true;
        if (props.widget) syncCounters();
      });

      if (props.widget) syncCounters();
    });

    onUnmounted(() => {
      const channelName = 'private-digital-labels';
      console.log(`unsubscribing from "${channelName}"...`, { $pusher: pusher });
      pusher.unsubscribe(channelName);
    });

    return { syncCounters, dateFormatter, loading, counters, alertModal };
  },
};
</script>

<template>
  <div v-if="widget" class="d-flex m-0 ps-5" style="height: 8rem">
    <CardCounter
      :label="'Tot. Tag'"
      :loading="loading"
      :value="counters?.attached_devices + counters?.empty_devices"
    />
    <CardCounter
      :label="'Tot. Tag assegnati'"
      :loading="loading"
      :value="counters?.attached_devices"
    />
    <CardCounter
      :label="'Tot. Tag non assegnati'"
      :loading="loading"
      :value="counters?.empty_devices"
    />
    <div class="d-flex justify-content-center align-items-end m-2" style="width: 4rem">
      <img
        class="p-1 rounded-circle shadow cp"
        style="background: #a58aba"
        src="@/assets/icons/sync.svg"
        width="40"
        height="40"
        alt="sync"
        @click="syncCounters()"
      />
    </div>
  </div>
  <Modal
    v-if="alertModal.show"
    :modal_id="alertModal.id"
    :size="'lg'"
    :title="`${$t(alertModal.title)}!`"
    :decline_label="$t('close')"
    :options="alertModal.options"
    @close="alertModal.show = false"
  >
    <div class="p-4">
      <div class="d-flex justify-content-center align-items-center">
        <img class="p-3" src="@/assets/icons/danger.svg" width="75" alt="danger" />
        <h3 class="pastel-red text-uppercase fw-bold">{{ $t(alertModal.subTitle) }}</h3>
        <img class="p-3" src="@/assets/icons/danger.svg" width="75" alt="danger" />
      </div>
      <h4>
        {{ $t("Provide supplies to the following department") }}:
        <span class="fw-bold text-uppercase">{{ alertModal.area }}</span>
      </h4>
      <h4>{{ $t("Available Tags") }}: <span class="fw-bold">{{ alertModal.count }}</span></h4>
      <h4 v-if="alertModal.lastSentAt">
        {{ $t("Last notification received") }}: <span class="fw-bold">{{ dateFormatter(alertModal.lastSentAt) }}</span>
      </h4>
    </div>
  </Modal>
</template>
